import { jsx as l } from "react/jsx-runtime";
const o = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M4.879 2.879A3 3 0 1 1 9.12 7.12 3 3 0 0 1 4.88 2.88m10 0A3 3 0 1 1 19.12 7.12 3 3 0 0 1 14.88 2.88M8 9.749c0 .163-.054.32-.145.454A4.98 4.98 0 0 0 7 13c0 .52-.386 1-.907 1H3a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2.25a.75.75 0 0 1 .75.75m8 0c0 .163.054.32.145.454.54.798.855 1.76.855 2.797 0 .52.386 1 .907 1H21a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-2.25a.75.75 0 0 0-.75.75M8 22a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1zm1.879-11.121a3 3 0 1 1 4.242 4.242A3 3 0 0 1 9.88 10.88",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
